import React from 'react';
import './schedule.scss';

export const Schedule = () => {
  return <div className='page'>Schedule</div>;
};
